import {
  SET_LOCKERS_DATA,
  FETCH_LOCKERS_REQUEST,
  FETCH_LOCKER_DETAIL_REQUEST,
  SET_LOCKER_DETAIL_DATA,
} from './types'
import { Filter, NormalizedLocker, NormalizedLockers, LockerDetail } from './models'

export const fetchLockersDataRequest = (
  params: Filter
): Readonly<{
  type: 'FETCH_LOCKERS_REQUEST'
  payload: {
    params: Filter
  }
}> => {
  return {
    type: FETCH_LOCKERS_REQUEST,
    payload: {
      params: params,
    },
  }
}

export const setLockersData = (
  result: NormalizedLocker['_id'][],
  entities: NormalizedLockers
): Readonly<{
  type: 'SET_LOCKERS_DATA'
  payload: {
    lockers: {
      result: NormalizedLocker['_id'][]
      entities: NormalizedLockers
    }
  }
}> => {
  return {
    type: SET_LOCKERS_DATA,
    payload: {
      lockers: { result, entities },
    },
  }
}

export const fetchLockerDetailRequest = (
  id: string | string[]
): Readonly<{
  type: 'FETCH_LOCKER_DETAIL_REQUEST'
  payload: {
    id: string | string[]
  }
}> => {
  return {
    type: FETCH_LOCKER_DETAIL_REQUEST,
    payload: {
      id: id,
    },
  }
}

export const setLockerDetailData = (
  result: LockerDetail
): Readonly<{
  type: 'SET_LOCKER_DETAIL_DATA'
  payload: {
    lockerDetail: {
      result: LockerDetail
    }
  }
}> => {
  return {
    type: SET_LOCKER_DETAIL_DATA,
    payload: {
      lockerDetail: { result },
    },
  }
}
